<template>
  <b-container class="px-0 px-md-3 py-4 py-md-5">
    <div class="accordionComp">
      <EmpleabilidadIngreso :carrera1="carrera1" :carrera2="carrera2" />
      <MatriculacionRendimientoCollapse
        :carrera1="carrera1"
        :carrera2="carrera2"
      />
      <TiempoDuracionCollapse :carrera1="carrera1" :carrera2="carrera2" />
      <UbicacionCollapse :carrera1="carrera1" :carrera2="carrera2" />
    </div>
  </b-container>
</template>

<script>
import EmpleabilidadIngreso from "@/components/comparadorITP/EmpleabilidadIngresoCollapse";
import MatriculacionRendimientoCollapse from "@/components/comparadorITP/MatriculacionRendimientoCollapse";
import TiempoDuracionCollapse from "@/components/comparadorITP/TiempoDuracionCollapse";
import UbicacionCollapse from "@/components/comparadorITP/UbicacionCollapse";
export default {
  name: "Comparacion",
  props: {
    carrera1: { type: Object },
    carrera2: { type: Object }
  },
  components: {
    EmpleabilidadIngreso,
    MatriculacionRendimientoCollapse,
    TiempoDuracionCollapse,
    UbicacionCollapse
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/comparadorITP/Comparacion.vue